import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import FloatingSocial from "@/components/feature/FloatingSocial";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsSection from "@/pages/home/components/StatsSection";
import AboutSection from "@/pages/home/components/AboutSection";
import ProjectsSection from "@/pages/home/components/ProjectsSection";
import TeamSection from "@/pages/home/components/TeamSection";
import ServicesSection from "@/pages/home/components/ServicesSection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const scrollTo = (location.state as { scrollTo?: string } | null)?.scrollTo;
    if (!scrollTo) return;
    const tryScroll = (attempts = 0) => {
      const el = document.querySelector(scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else if (attempts < 10) {
        setTimeout(() => tryScroll(attempts + 1), 50);
      }
    };
    tryScroll();
  }, [location.state]);

  return (
    <div className="min-h-screen bg-white font-sans page-fade">
      <Navbar />
      <FloatingSocial />
      <main>
        <HeroSection />
        <StatsSection />
        <AboutSection />
        <ProjectsSection />
        <TeamSection />
        <ServicesSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
